import { render, staticRenderFns } from "./RequestNew.vue?vue&type=template&id=fb3f2324"
import script from "./RequestNew.vue?vue&type=script&lang=js"
export * from "./RequestNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports